import { KompisCarouselItem } from '@inter-ikea-kompis/react-components';
import { useCore } from 'contexts/core';
import useIsRtl from 'hooks/useIsRtl';
import { NoneOption } from 'rangeConfig/@types';
import styled from 'styled-components';
import None from 'rangeConfig/Icons/None.svg?react';
import { useBehaviorTracker } from 'contexts/behaviors';

const NoneOptionItem = styled.div<{ isRtl: boolean }>`
  position: relative;
  width: 4.5rem;
  height: 4.5rem;
`;

const StyledNoneIcon = styled(None)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 3rem;
  height: 3rem;
`;

const Image = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
`;

type NoneOptionProps = {
  noneOption: NoneOption;
};

const NoneOptionWidget = ({ noneOption }: NoneOptionProps) => {
  const behaviorTracker = useBehaviorTracker();
  const isRtl = useIsRtl();
  const coreApi = useCore();

  const onNoneOptionSelected = () =>
    behaviorTracker.trigger('removeProducts', null, noneOption.behaviors);

  return (
    <KompisCarouselItem>
      <NoneOptionItem
        isRtl={isRtl}
        data-selected={noneOption.selected(coreApi)}
        onClick={onNoneOptionSelected}
        style={{
          border: noneOption.selected(coreApi) ? '1px solid black' : '1px solid transparent'
        }}
      >
        {noneOption.image ? <Image src={noneOption.image} /> : <StyledNoneIcon />}
      </NoneOptionItem>
    </KompisCarouselItem>
  );
};

export default NoneOptionWidget;
